import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable()
export class AppIdInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // AQUÍ CAMBIA EL ID SEGÚN LA APP: 'pgarcia' o 'luksfg'
        const appId = 'pgarcia';

        const modifiedReq = req.clone({
            headers: req.headers.set('X-App-ID', appId)
        });

        return next.handle(modifiedReq);
    }
}